import Script from 'next/script';

const ClarityScript: React.FC = () => {
  // For now it was decided to load Clarity script without consent check
  // const hasStatisticsConsent = useCookiebotCategoryConsent('statistics');
  // if (!hasStatisticsConsent) return null;

  return (
    <Script
      id="clarity-script"
      strategy="afterInteractive"
      data-cookieconsent="statistics"
      dangerouslySetInnerHTML={{
        __html: `
          (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window, document, "clarity", "script", "t0wohfruk2");
        `,
      }}
    />
  );
};

export default ClarityScript;
